import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function ErrorPage({ message }) {
    return (
        <Container className="text-center mt-5">
            <h1>오류 발생</h1>
            <p>{message || '알 수 없는 오류가 발생했습니다.'}</p>
            <Button as={Link} to="/" variant="primary">
                홈으로 돌아가기
            </Button>
        </Container>
    );
}

export default ErrorPage;